<button [class]="primaryBtn" [disabled]="disabled">
    <img *ngIf="showImage" [src]="imageSrc" [alt]="imageAlt" [ngClass]="btnImg">
    {{buttonText}}
</button>
